
export const encryptPassword = async (publicKey, password) => {
  return await encryptRSA(publicKey, password);
};

async function encryptRSA(publicKey, plaintext) {
  const cryptoKey = await window.crypto.subtle.importKey(
    'spki',
    base64UrlSafeToArrayBuffer(publicKey),
    { name: 'RSA-OAEP', hash: { name: 'SHA-256' } },
    true,
    ['encrypt']
  );
  const encoded = new TextEncoder().encode(plaintext);
  const encrypted = await window.crypto.subtle.encrypt(
    { name: 'RSA-OAEP' },
    cryptoKey,
    encoded
  );
  return arrayBufferToBase64UrlSafe(encrypted);
}

function arrayBufferToBase64UrlSafe(buffer) {
  const bytes = new Uint8Array(buffer);
  let binary = '';
  for (let i = 0; i < bytes.byteLength; i++) {
    binary += String.fromCharCode(bytes[i]);
  }
  return btoa(binary).replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '');
}

function base64UrlSafeToArrayBuffer(base64) {
  const binaryString = atob(base64.replace(/-/g, '+').replace(/_/g, '/'));
  const bytes = new Uint8Array(binaryString.length);
  for (let i = 0; i < binaryString.length; i++) {
    bytes[i] = binaryString.charCodeAt(i);
  }
  return bytes.buffer;
}

// String to Base64 URL-safe encoding
export const stringToBase64UrlSafe = (input) => {
  const base64 = btoa(
    encodeURIComponent(input).replace(/%([0-9A-F]{2})/g, (match, p1) =>
      String.fromCharCode('0x' + p1)
    )
  );
  return base64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
};

// Base64 URL-safe to String decoding
export const base64UrlSafeToString = (input) => {
  if (!input) {
    return '';
  }

  try {
    input = input.replace(/-/g, '+').replace(/_/g, '/');
    const decoded = atob(input);
    return decodeURIComponent(
      decoded
        .split('')
        .map((char) => '%' + ('00' + char.charCodeAt(0).toString(16)).slice(-2))
        .join('')
    );
  } catch (error) {
    return input;
  }
};
